import { __assign, __awaiter, __extends, __generator } from "tslib";
import { StratusClient } from '../stratus-client';
/**
 * Client for making Verify User Code Service API calls.
 */
var DeviceAuthGrantClient = /** @class */ (function (_super) {
    __extends(DeviceAuthGrantClient, _super);
    function DeviceAuthGrantClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/deviceauthgrant';
        _this.apiVersion = '1';
        _this.verifyEndpoint = '/verify';
        _this.confirmEndpoint = '/confirm';
        return _this;
    }
    /**
     * Returns the expected schema of verify device API.
     *
     * @returns schema in object format
     */
    DeviceAuthGrantClient.prototype.verifiedDeviceDetails = function (user_code, hold_device, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: this.verifyEndpoint,
                        data: "user_code=".concat(user_code, "&hold_device=").concat(hold_device),
                        headers: __assign({ 'content-type': 'application/x-www-form-urlencoded' }, headers),
                    })];
            });
        });
    };
    DeviceAuthGrantClient.prototype.confirmedDeviceDetails = function (device_uuid, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.post({
                        url: this.confirmEndpoint,
                        data: "device_uuid=".concat(device_uuid),
                        headers: __assign({ 'content-type': 'application/x-www-form-urlencoded' }, headers),
                    })];
            });
        });
    };
    return DeviceAuthGrantClient;
}(StratusClient));
export { DeviceAuthGrantClient };
//# sourceMappingURL=device-auth-grant-svc.js.map